import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth';
import users from './modules/users';
import orgs from './modules/orgs';
import running from './modules/running';
import dashboard from './modules/dashboard';
import events from './modules/events';
import apps from './modules/apps';
import socket from './modules/socket';
import mode from './modules/mode';
import statuses from './modules/statuses';
import ui from './modules/ui';
import enveditor from './modules/enveditor';
import editor from './modules/editor';
import datamapper from './modules/datamapper'
import backenddata from './modules/data'
import build from './modules/build';

import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

const dataState = createPersistedState({
  storage: window.sessionStorage,
  paths: ['auth.clients', 'apps', 'dashboard', 'users', 'build', 'events.eventsLogFilterOptions'],
})

const store = new Vuex.Store({
  namespaced: true,
  plugins: [dataState],
  modules: {
    auth,
    users,
    orgs,
    running,
    dashboard,
    events,
    apps,
    socket,
    mode: mode,
    statuses,
    ui,
    enveditor,
    editor,
    datamapper,
    backenddata,
    build,
  },
});

export default store;